import React from 'react'

const Antenna = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M5 21V17M10.3333 21V13M15.6667 21V9M21 21V5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.16667"></path>
</svg>
    )
}

export default Antenna
